import type { ReactNode } from 'react';

import Icon from 'components/Icon';
import { cnm } from 'utils/classNames';

export type Size = 'md' | 'sm';
export type Variant = 'negative' | 'positive';

interface Props {
	className?: string;
	displayType?: 'block' | 'inline';
	size?: Size;
	text: ReactNode;
	variant: Variant;
}

export default function Status({
	className,
	displayType = 'block',
	size = 'md',
	text,
	variant,
}: Props) {
	const Tag = displayType === 'inline' ? 'span' : 'div';
	return (
		<Tag
			className={cnm(
				'items-start align-top break-words',
				displayType === 'inline' ? 'inline-flex' : 'flex',
				size === 'sm' && 'text-xs',
				size === 'md' && 'text-md',
				className,
			)}
		>
			<Icon
				size={size === 'md' ? 24 : 16}
				name={
					variant === 'positive' ? 'circle-check' : 'circle-cancel-outlined'
				}
				color={variant === 'positive' ? 'success' : 'error'}
				className={size === 'md' ? 'mr-2' : 'mr-1'}
			/>
			{text}
		</Tag>
	);
}
Status.displayName = 'Status';
